import { useCallback, useRef, useState } from 'react';

const SCROLL_THRESHOLD = 4;

export const useScrolledToBottom = () => {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      if (hasScrolledToBottom) return;
      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
      if (scrollHeight - scrollTop - clientHeight <= SCROLL_THRESHOLD)
        setHasScrolledToBottom(true);
    },
    [hasScrolledToBottom]
  );

  const contentRef = useRef<HTMLDivElement>(null);

  const handleContentMount = useCallback((node: HTMLDivElement | null) => {
    contentRef.current = node;
    if (!node) return;
    if (node.scrollHeight <= node.clientHeight) {
      setHasScrolledToBottom(true);
    }
  }, []);

  return { hasScrolledToBottom, handleScroll, handleContentMount };
};
